import React, { Component } from "react";
import { Card, Form, Table } from "tabler-react";
import Crud_Catalogos from "../../../herramientas/Crud_Catalogos";

class UsuarioClientes extends Component {
    constructor() {
        super();
        this.state = {
            clientes:[],
            pClientes:[],
        };
    }
    componentWillMount(){
      this.getfuntion("get", "", "", "cli_usuarios_clientes/usuario/"+this.props.usuario.id+"/plataforma/"+this.props.idPlataforma, "usuarios_clientes");
      this.getfuntion("get", "", "", "cliente/plataforma/"+this.props.idPlataforma, "clientes");
    }
    getfuntion = (metodo="get", obj=[], id="", catalogo="perfilesFuncionalidades", stateVar= "columnas", hiddenModl="") =>{
        return Crud_Catalogos(catalogo, "monitoreoPage", metodo, id, obj,"" , stateVar, hiddenModl, []).then((returnVal) => {
            /*** filtro de variables  */
            switch (metodo) {
              case "get":
                if (stateVar === "clientes")
                  this.setState({ clientes: returnVal });
                if (stateVar === "usuarios_clientes")
                  this.setState({ pClientes: returnVal });
                break;
              case "post":
                if (stateVar === "usuarios_clientes"){
                  let pClientesTemp= this.state.pClientes;  
                  pClientesTemp.push(returnVal);
                  this.setState({ pClientes: pClientesTemp });
                }
                break;
              case "delete":
                if (stateVar === "usuarios_clientes" && returnVal){ 
                  let varTemp= this.state.pClientes;
                  varTemp.map((elem, index )=>{
                    if(obj.idCliente === elem.idCliente ){ varTemp.splice( index, 1);  this.setState({ pClientes: varTemp }); }
                  });
                }
                break;
              default:
                break;
            }
          }).catch(err =>{
              console.log(err);
        })
      }
    changeCliente=(event)=>{
      let objTemp= {idUsuario: this.props.usuario.id, idCliente: parseInt(event.target.value, 10), idPlataforma: this.props.idPlataforma };
      if( event.target.checked ){
        this.getfuntion("post", objTemp, "", "cli_usuarios_clientes","usuarios_clientes");  
      }else{
        this.getfuntion("delete", objTemp, this.props.usuario.id+"/"+parseInt(event.target.value, 10)+"/"+this.props.idPlataforma, "cli_usuarios_clientes","usuarios_clientes");
      }      
    }
    getCliente    =(id)=>{ for( let  item of this.state.pClientes ){  if( item.idCliente === id ){   return true; } } return false; }
    render() {
        return (
            <div>
              <Card>
                <Card.Body>
                  <Table cards={true} striped={true} responsive={true} className="table-vcenter" >
                    <Table.Header align="center">
                        <Table.ColHeader>Id</Table.ColHeader>
                        <Table.ColHeader>Cliente  </Table.ColHeader>
                        <Table.ColHeader>estatus </Table.ColHeader>
                    </Table.Header>
                    <Table.Body>
                      {this.state.clientes.map((t, index) =>
                        <Table.Row align="center">
                            <Table.Col>{ t.id }</Table.Col>
                            <Table.Col>{ t.nombre }</Table.Col>
                            <Table.Col><Form.Switch type="Checkbox" name="toggle" value={t.id} checked= { this.getCliente(t.id) } onChange={ this.changeCliente} /></Table.Col>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>                                                            
                </Card.Body>
              </Card>
                <br/>
            </div>
        );
    }
}

export default UsuarioClientes;